import script from "./UserLog.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserLog.vue?vue&type=script&lang=ts&setup=true"

import "./UserLog.vue?vue&type=style&index=0&id=9700fcf0&lang=scss"

const __exports__ = script;

export default __exports__